<template>
	<ViewFeedItem class="view-feed-contentnewsrow">
		<template v-slot:header>
			<ViewLayoutModuleHeader v-bind:title="title" v-bind:subtitle="subtitle">
				<RouterLink v-bind:to="{ name: 'PageContent' }">
					<strong>View All</strong>
				</RouterLink>
			</ViewLayoutModuleHeader>
		</template>

		<template v-slot:body>
			<ViewUiStateLoader v-if="contentCollection.length === 0" />

			<div class="cards" v-if="contentCollection.length > 0">
				<ViewContentCard
					v-bind:contentModel="contentModel"
					v-bind:key="contentModel.id"
					v-for="contentModel in contentCollection.models"
					v-on:select="Handle_OnSelectContent"
				/>
			</div>
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { mounted } from '@/Utility/Decorators';

	/**
	 * Horizontally scrolling row of recent news article cards. Mirrors
	 * the ergonomics of ViewFeedVenueFeed but for the Content collection.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedContentNewsRow extends ViewBase {
		/**
		 * Subtitle copy beneath the module header
		 *
		 * @return string
		 */
		protected get subtitle(): string {
			return ''; // 'Latest from the community';
		}

		/**
		 * Title copy in the module header
		 *
		 * @return string
		 */
		protected get title(): string {
			return 'In the news';
		}

		/**
		 * Source collection of news content
		 *
		 * @type ChalkySticks.Collection.Content
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Content.collection({ limit: 8 }).news(),
		})
		public contentCollection!: ChalkySticks.Collection.Content;

		/**
		 * Fetch news items on mount.
		 *
		 * @return Promise<void>
		 */
		@mounted
		public async setup(): Promise<void> {
			await this.contentCollection.fetch();
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param ChalkySticks.Model.Content contentModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectContent(contentModel: ChalkySticks.Model.Content): Promise<void> {
			this.$router.push({
				name: 'PageContentItem',
				params: {
					id: contentModel.getSlug(),
				},
			});
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	// Layout
	// ---------------------------------------------------------------------------

	.view-feed-contentnewsrow {
		.title {
			font-size: 1.2rem;
		}

		.body {
			padding: 0 0 var(--padding);
		}

		.cards {
			-webkit-overflow-scrolling: touch;
			display: flex;
			gap: 0.75rem;
			overflow-x: auto;
			overflow-y: hidden;
			padding: 0 var(--padding) 0.5rem;
			scroll-snap-type: x mandatory;

			&::-webkit-scrollbar {
				display: none;
			}
		}

		.view-content-card {
			flex: 0 0 auto;
			scroll-snap-align: start;
			width: 16rem;
		}
	}
</style>
